<template>
  <Transition name="app-loading-fade">
    <div v-if="visible" class="app-loading-overlay">
      <div class="app-loading-box">
        <div class="app-loading-ring" />
        <div class="app-loading-logo">
          <Icon icon="solar:flame-bold-duotone" />
        </div>
        <div class="app-loading-text">{{ text }}</div>
        <div class="app-loading-bar">
          <div class="app-loading-bar-fill" />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { Icon } from '@iconify/vue'
import { useAppLoading } from '@/composables/useAppLoading'

const { visible, text } = useAppLoading()
</script>

<style scoped>
.app-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle at 50% 40%, rgba(0, 245, 255, 0.08) 0%, transparent 55%),
              rgba(3, 6, 14, 0.92);
  backdrop-filter: blur(6px);
}

.app-loading-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-4, 16px);
}

.app-loading-ring {
  position: absolute;
  width: 96px;
  height: 96px;
  border: 2px solid rgba(0, 245, 255, 0.12);
  border-top-color: var(--color-primary, #00f5ff);
  border-right-color: var(--color-primary, #00f5ff);
  border-radius: 50%;
  animation: app-loading-spin 0.9s linear infinite;
  box-shadow: 0 0 24px rgba(0, 245, 255, 0.25);
}

.app-loading-logo {
  position: relative;
  width: 96px;
  height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: var(--color-primary, #00f5ff);
  filter: drop-shadow(0 0 8px var(--color-primary-glow, #66f7ff));
}

@keyframes app-loading-spin {
  to { transform: rotate(360deg); }
}

.app-loading-text {
  margin-top: 8px;
  font-size: var(--font-size-sm, 14px);
  color: var(--text-secondary, #8a93a6);
  letter-spacing: 2px;
}

.app-loading-bar {
  width: 180px;
  height: 3px;
  border-radius: 2px;
  background: rgba(0, 245, 255, 0.12);
  overflow: hidden;
}

.app-loading-bar-fill {
  width: 40%;
  height: 100%;
  border-radius: 2px;
  background: linear-gradient(90deg, transparent, var(--color-primary, #00f5ff), transparent);
  animation: app-loading-slide 1.2s ease-in-out infinite;
}

@keyframes app-loading-slide {
  0% { transform: translateX(-120%); }
  100% { transform: translateX(320%); }
}

.app-loading-fade-enter-active,
.app-loading-fade-leave-active {
  transition: opacity 0.3s ease;
}
.app-loading-fade-enter-from,
.app-loading-fade-leave-to {
  opacity: 0;
}
</style>
